/// <amd-module name="SearchUI/Components/WikiSearchResultComponent/WikiSearchResultItem" />
import * as React from "react";
import * as ReactDOM from "react-dom";

import { format } from "VSS/Core/Util/String";
import { WikiResult, WikiHitSnippet } from "SearchUI/Contracts/Search.SharedLegacy";
import { WikiSearchResultProps } from "SearchUI/Components/WikiSearchResultComponent/WikiSearchResultItem.Props";
import { SearchResultItemComponent } from "SearchUI/Components/SearchResultItemComponent/SearchResultItemComponent";
import * as ComponentHelpers from "SearchUI/Helpers/SearchResultsComponentHelper";
import * as Resources from "SearchUI/Search.Resources.SearchUI";
import * as WikiHelper from "SearchUI/Helpers/WikiHelper";

import "VSS/LoaderPlugins/Css!SearchUI/Components/WikiSearchResultComponent/WikiSearchResultItem";

export const WikiSearchResultRow = (props: WikiSearchResultProps): JSX.Element => {
    const fileNameHit = getWikiPageHitDisplayName(props.result);
    const contentHitIndex = findHitIndex(props.result.hits, "content");
    let contentText: string[];
    if (contentHitIndex >= 0) {
        contentText = props.result.hits[contentHitIndex].highlights;
    }

    const titleAriaLabel = getWikiPageAriaLabel(props.result);
    const titleComponent = fileNameHit
        ? <span dangerouslySetInnerHTML={{
            __html: props.sanitizeHtml(fileNameHit)
        }
        } />
        : <span>{getWikiPageName(props.result.fileName)} </span>;
    const titleComponentWithLink = ComponentHelpers.getTitleComponent(props.wikiPageUrl, titleComponent, titleAriaLabel, props.onFileNameClicked);
    const content =  getWikiContentHits(props.result.hits, props.sanitizeHtml);


    return <SearchResultItemComponent
        titleComponent={titleComponentWithLink}
        subTitleComponent={props.rowSubTitle}
        descriptionComponent={content}
    />;
};

export const InText = (): JSX.Element => {
    return (
        <span className="in-text"> {Resources.In} </span>
    );
};

export function getWikiPageAriaLabel(result: WikiResult): string {
    const filePageName = getWikiPageName(result.fileName);
    return format(Resources.WikiPageAriaLabel, filePageName);
}

export function getWikiPageName(fileName: string): string {
    return WikiHelper.getWikiPagePathFromGitPath(WikiHelper.removeExtensionfromPagePath(fileName));
}

function getWikiContentHits(hits: WikiHitSnippet[], sanitizeHtml: (html: string) => string): JSX.Element {
    // Task: #1083185 to convert hard coded content to contract based enum or constant
    const contentHitIndex = findHitIndex(hits, "content");
    if (contentHitIndex >= 0) {
        const contentText: string[] = hits[contentHitIndex].highlights;

        return (
            <div className="wiki-search-hits">
                <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(contentText.join(" ")) }} />
            </div>);
    }

    return null;
}

function getWikiPageHitDisplayName(item: WikiResult): string {
    // Task: #1083185 to convert hard coded fileNames to contract based enum or constant
    const wikiPageHitIndex = findHitIndex(item.hits, "fileNames");

    if (wikiPageHitIndex < 0) {
        return null;
    }

    const gitReferenceName = item.hits[wikiPageHitIndex].fieldReferenceName;
    const wikiReferenceName = WikiHelper.getWikiPagePathFromGitPath(gitReferenceName);

    let highlightedStr = item.hits[wikiPageHitIndex]
        && item.hits[wikiPageHitIndex].highlights.length > 0
        ? item.hits[wikiPageHitIndex].highlights[0] : null;

    let index = 0;
    do {
        highlightedStr.replace(gitReferenceName, wikiReferenceName);
    } while ((index = highlightedStr.indexOf(gitReferenceName, index + 1)) > -1);

    return highlightedStr;
}

// implemented only for IE
function findHitIndex(hits: WikiHitSnippet[], fieldName: string): number {
    for (let hitIndex = 0; hitIndex < hits.length; hitIndex++) {
        if (hits[hitIndex].fieldReferenceName === fieldName) {
            return hitIndex;
        }
    }

    return -1;
}
